var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('balance',{attrs:{"title":_vm.title,"cols":_vm.cols,"url":_vm.url,"showAccountFilters":false,"getAccountLedgerQuery":_vm.getAccountLedgerQuery}})}
var staticRenderFns = []

export { render, staticRenderFns }